import { useFormContext } from "react-hook-form";
import { ICreditPaymentoForm } from "../../../types/forms";
import FormInput from "../../Elements/FormInput";

const CreditCardSection = () => {
  const { 
    register, 
    setValue, 
    formState: { errors } 
  } = useFormContext<ICreditPaymentoForm>();

  return (
    <>
      <div className="row g-3">
        <div className="col-sm-8">
          <div className="form-floating">
            <FormInput
              name="cardNumber"
              register={register}
              type="text"
              id="txtNumeroCartao"
              placeholder="Número do Cartão:"
              error={errors.cardNumber?.message}
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.securityCode?.message}
              name="securityCode"
              type="text"
              id="txtCodSeguranca"
              placeholder="Cod de Segurança:"
            />
          </div>
        </div>
        <div className="col-sm-12">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.nameInCard?.message}
              name="nameInCard"
              type="text"
              id="txtNomeCartao"
              placeholder="Nome impresso no cartão..."
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.monthExpiration?.message}
              onChange={(e) =>
                e.target.value.length < 3
                  ? setValue("monthExpiration", e.target.value)
                  : setValue("monthExpiration", e.target.value.slice(0, 2))
              }
              name="monthExpiration"
              type="text"
              id="txtMesValidade"
              placeholder="Mês da Validade (MM):"
            />
          </div>
        </div>
        <div className="col-sm-4">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.yearExpiration?.message}
              onChange={(e) =>
                e.target.value.length < 3
                  ? setValue("yearExpiration", e.target.value)
                  : setValue("yearExpiration", e.target.value.slice(0, 2))
              }
              name="yearExpiration"
              type="text"
              id="txtAnoValidade"
              placeholder="Ano da Validade(AA):"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default CreditCardSection;